import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
// import home from '@/components/home/home'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
      {
        path: '/',
        redirect: {
          name: 'myHome'
        }
      },
      //路由懒加载 
      {
        path:'/myHome',
        name:'myHome',
        component:resolve => require(['@/components/home/home'],resolve)
      },

      {
        path:'/note_ags',
        name: 'note_ags',
        component:resolve=>require (['@/components/note_ags/index'],resolve),
        meta:{
          title: '发短信'
        }
      },
    {
      path:'/thread',
      name: 'thread',
      component:resolve=>require (['@/components/thread/index'],resolve),
      meta:{
        title: '线索详情'
      }
    },
    {
      path: '/user_feedback',
      name: 'user_feedback',
      component:resolve=> require (['@/components/user_feedback/index'],resolve),
      meta:{
        title: '用户反馈'
      }
    },
    {
      path: '/login',
      name: 'login',
      component:resolve=> require (['@/components/login/index'],resolve),
      meta:{
        title: '登录'
      }
    },
    {
      path: '/punching',
      name:'punching',
      component:resolve => require (['@/components/punching/index'],resolve),
      meta:{
        title :'打卡记录'
      }
    },
    {
      path: '/examine',
      name : 'examine',
      component:resolve => require(['@/components/examine/index'],resolve),
      meta:{
        title :'审核'
      }
    },
    {
      path:'/approval',
      name:'approval',
      component:resolve => require (['@/components/approval/index'],resolve),
      meta:{
        title:'线索审批'
      }
    },
    {
        path:'/conversion',
        name:'conversion',
        component:resolve=> require (['@/components/conversion/index'],resolve),
        meta:{
          title:'线索报表'
        }
    },
    {
        path:'/Receive',
        name:'Receive',
        component:resolve=> require (['@/components/Receive/index'],resolve),
        meta:{
          title:'消息'
        }
    },
    {
      path:'/aseLeave',
      name:'aseLeave',
      component:resolve => require (['@/components/aseLeave/index'],resolve),
      meta:{
        title:'请假'
      }
    },
    {
      path:'/Ranking',
      name:'Ranking',
      component:resolve=> require (['@/components/Ranking/index'],resolve),
      meta:{
        title:'排名'
      }
    },
    {
      path:'/order_statement',
      name:'order_statement',
      component:resolve=> require (['@/components/order_statement/index'],resolve),
      meta:{
        title:'订单报表'
      }
    },
    {
      path:'/company',
      name:'company',
      component:resolve=> require (['@/components/company/index'],resolve),
      meta:{
        title:'联系方式'
      }
    },

  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js